import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { ErrorCode } from '../login.constants';
import { View, Text, StyleSheet } from 'react-native';
import {Button} from '../../../components/core/Button';
import useTimer from '../../../commonComponents/useTimer';
import Colors from '../../../assets/Color/Colors';
import { globalFontStyle } from '../../../assets';
import OTPTextView from '../../../commonComponents/OtpComp';
import { check, warning } from '../../../utils/images';
import ShowError from '../../../common/ShowError';
import { globalImport } from '../../../common/globalImports';
import { isMobile } from '../../../utils/commonMethods';

function VerifyOtp({ onOTPSubmit, isInternalVerify, mobileNo, emailLogin }) {
  const { register, handleSubmit, formState } = useForm({ mode: 'onChange' });
  const [error, setError] = useState(null);
  const [otpbox, setOtpBox] = useState('');
  const [isLoginBtnValid, setIsLoginBtnValid] = useState(false);

  const [seconds, resetTimer] = useTimer(30);

  const handleChange = (text) => {
    setOtpBox(text);
    setIsLoginBtnValid(text.length === 6);
  };

  const onFormSubmit = data => {
    onOTPSubmit(otpbox);
  };

  const verifyOtpSuccess = useSelector(({ login }) => login.verifyOtp_success);
  const otpReSuccess = useSelector(({ login }) => login.interimRegisterSuccess);

  const onResend = () => {
    onOTPSubmit(null, true);
  };

  //verify otp error handling
  useEffect(() => {
    if (verifyOtpSuccess && !verifyOtpSuccess?.verified) {
      if (ErrorCode[verifyOtpSuccess?.errorCode]) {
        setError({
          val: 'Retry',
          message: verifyOtpSuccess?.msg,
          errorClass: { color: Colors.red },
          borderColor: Colors.red,
        });
      } else {
        setError({
          val: 'Retry',
          message: verifyOtpSuccess?.msg,
          errorClass: { color: Colors.red },
          borderColor: Colors.red,
        });
      }
    } else if (verifyOtpSuccess && verifyOtpSuccess?.verified) {
      setError({
        val: 'Applied',
        message: verifyOtpSuccess?.msg,
        errorClass: { color: Colors.green },
        borderColor: Colors.green,
      });
    }
  }, [verifyOtpSuccess]);

  //after response from sendotp, what to show and wether to do timer reset
  useEffect(() => {
    if (otpReSuccess?.success && seconds === 0) {
      resetTimer();
      setError({
        val: 'Retry',
        message: '',
        errorClass: { color: Colors.red },
      });
      //registerUserInterim(false); //after sendotp, changing the default otp response to false
    }
  }, [otpReSuccess]);

  return (
    <View style={styles.container}>
      <View style={styles.contentContainer}>
        <Text style={styles.heading}>Verify Phone</Text>
        <Text style={styles.subText}>
          OTP has been sent to {emailLogin ? mobileNo : `+91 ${mobileNo}`}
        </Text>

        <View style={styles.otpContainer}>
          <OTPTextView
            containerStyle={styles.otpInputContainer}
            handleTextChange={handleChange}
            inputCount={6}
            keyboardType="numeric"
            textInputStyle={styles.otpInput}
            offTintColor={error ? error?.borderColor : '#E5E7EB'}
            tintColor={error ? error?.borderColor : Colors.black}
            autoFocus={true}
            secureTextEntry={false}
            editable={true}
            clearTextOnFocus={false}
            selectTextOnFocus={false}
          />
        </View>

        {seconds === 0 && !otpReSuccess?.disableOTPSend && error ? (
          <View style={styles.errorContainer}>
            {error !== null && error?.message !== '' && (
              <ShowError error={error} />
            )}
            <View style={styles.resendContainer}>
              <Text
                style={styles.resendText}
                onPress={onResend}>
                Resend OTP
              </Text>
            </View>
          </View>
        ) : (
          <View style={styles.timerContainer}>
            {error !== null && error?.message !== '' && (
              <ShowError error={error} />
            )}
            {!otpReSuccess?.disableOTPSend && (
              <View>
                {seconds !== 0 ? (
                  <Text style={styles.timerText}>
                    {`Resend OTP in ${seconds} seconds`}
                  </Text>
                ) : (
                  <Text
                    style={styles.resendText}
                    onPress={onResend}>
                    Resend OTP
                  </Text>
                )}
              </View>
            )}
          </View>
        )}

        <View style={styles.buttonContainer}>
          <Button
            variant="primary"
            disabled={!isLoginBtnValid}
            onPress={handleSubmit(onFormSubmit)}
            style={{
              marginBottom: 20,
              marginTop: 30,
              height: 48,
              width: !isMobile() ? '100%' : undefined,
              flex: !globalImport.isWeb ? 0 : undefined
            }}
          >
            {isInternalVerify ? 'Confirm' : 'Verify OTP'}
          </Button>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.bgWhite,
  },
  contentContainer: {
    alignItems: 'center',
    paddingTop: 40,
  },
  heading: {
    ...globalFontStyle.appFontHeading,
    fontSize: 24,
    fontWeight: '700',
    color: Colors.black,
    marginBottom: 8,
    textAlign: 'center',
  },
  subText: {
    ...globalFontStyle.appFontBody,
    color: '#6B7280',
    marginBottom: 32,
    textAlign: 'center',
  },
  otpContainer: {
    width: '100%',
    alignItems: 'center',
    marginBottom: 24,
  },
  otpInputContainer: {
    justifyContent: 'center',
    width: '100%',
    maxWidth: 320,
    height: 60,
  },
  otpInput: {
    ...globalFontStyle.appFontSubHeading,
    color: Colors.black,
    borderWidth: 1,
    width: 44,
    height: 44,
    marginHorizontal: 4,
    borderRadius: 6,
    textAlign: 'center',
    fontSize: 20,
    backgroundColor: 'transparent',
    borderColor: '#E5E7EB',
    padding: 0,
    caretColor: 'transparent',
  },
  errorContainer: {
    alignItems: 'center',
    width: '100%',
  },
  resendContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: 20,
  },
  timerContainer: {
    alignItems: 'center',
    width: '100%',
  },
  resendText: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.black,
    borderBottomWidth: 2,
    borderBottomColor: Colors.black,
  },
  timerText: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.lightgrey,
    textAlign: 'center',
    paddingTop: 20,
  },
  buttonContainer: {
    width: '100%',
    paddingVertical: 30,
  },
  button: {
    flex: globalImport.isWeb ? {} : 0,
    marginTop: 15,
    height: 48,
  },
});

export default React.memo(VerifyOtp);
